<template>
  <h2 class="pb-2 border-bottom">PRP & Microneedling</h2>
  <p>Regeneração Natural para Pele, Cabelo e Bem-Estar</p>
  <p>As terapias com PRP (Plasma Rico em Plaquetas) utilizam os próprios fatores de crescimento do corpo para estimular a cura natural e a regeneração. Sob supervisão médica, o PRP pode auxiliar no rejuvenescimento da pele, restauração capilar, alívio da dor e melhora do bem-estar — com mínimo tempo de recuperação.</p>
  <h3>Principais aplicações</h3>
  <ul>
    <li>PRP para rejuvenescimento da pele — estimula colágeno, melhora a textura e promove brilho natural.</li>
    <li>PRP para restauração capilar — fortalece folículos, reduz queda e estimula novos fios.</li>
    <li>PRP para articulações & dor — auxilia em artrite, tendinite e recuperação de lesões.</li>
    <li>PRP para bem-estar — terapias que apoiam vitalidade e confiança (O-Shot/P-Shot podem ser detalhados no site, mas não em anúncios).</li>
    <li>PRP para cicatrizes — reduz pigmentação e suaviza marcas de acne ou traumas.</li>
  </ul>
  <h3>Como funciona</h3>
  <ol>
    <li>Coleta de pequena amostra de sangue.</li>
    <li>Separação do PRP em centrífuga.</li>
    <li>Aplicação por microagulhamento ou injeção.</li>
    <li>Recuperação rápida — vermelhidão/inchaço leves por 24–48h.</li>
  </ol>
  <p>“O PRP une ciência e cura natural para restaurar equilíbrio e confiança de forma segura e eficaz.”</p>
</template>

<script>
export default {
  name: 'PRPMicroneedlingFacialContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
